import React, { useState, useEffect, useReducer, useRef, useMemo } from 'react';
import { Modal } from 'antd-mobile';
import classnames from 'classnames';
import IndexLayout from './components/IndexLayout';
import Cinema from './components/Cinema';
import { setSessonStorage, getSessonStorage, getQueryString, getCookie, commonGetCityId } from '@/utils/index';
import homeApi from '@/common/api';
import homeReq from '@/entity/module/home/homeAPi';
import { EIndexTypes, IMovieCinemeData } from '@/interface/index';
import SelectCityPart from '@/components/selectCityPart';
import store from './store/store';
import reducer from './store/reducer';
import './index.less';
import { connect } from 'dva';
import * as types from '@/components/selectCityPart/interfaces';

import { BFD_checkApp, BFD_changeAppAddress } from '@/utils/bfdApp';
import { TLang } from '@/utils/lang';
import DFWebUtilsTools from '@df-fe/df-web-utils-tools';
import { increaseLoading, decreaseLoading, timer } from '@/public';
import { CinemaSkeleton, FutureSkeleton, HotSkeleton } from '@/components/skeleton';
import { gioClick } from '@/utils/gioApi';
import { set } from 'js-cookie';
import MarketingPopup from '@df-mobile/marketing-popup';
import { checkXcx } from '@/utils/checkXcx';

interface loadType {
  type: EIndexTypes;
}

export const Context = React.createContext<any | null>(null);

const Home = function (props: any) {
  // const val = process.env.BASIC_URL
  // const val2 = process.env
  // console.log(val,val2)
  const [indexType, setIndexType] = useState<EIndexTypes>();
  const [bannerImgs, setBannerList] = useState([]);
  const [futureMovieData, setFutureMovieData] = useState<IMovieCinemeData | null>(null);
  // const [futureMovieData, setFutureMovieData] = useState<any>(null);
  const [movieTopData, setMovieTopData] = useState<IMovieCinemeData | null>(null);
  // const [movieTopData, setMovieTopData] = useState<any>(null);
  const [hotMovieData, setHotMovieData] = useState<IMovieCinemeData | null>(null);
  // const [hotMovieData, setHotMovieData] = useState<any>(null);
  const [hotPageIndex, setHotPageIndex] = useState<number>(1);
  const [futurePageIndex, setFuturePageIndex] = useState<number>(1);
  const [state, dispatch] = useReducer(reducer, store);
  const [audioInfo, setAudioInfo] = useState<any>({});

  /** #### 选择城市  ####  */
  const [historyCities, setHistoryCities] = useState<types.HistoryCities[]>([]);
  const [hotCity, setHotCity] = useState<types.HotCity[]>([]);
  const [cityList, setCityList] = useState<types.CityModel[]>([]);
  const [curentCity, setCurentCity] = useState<types.CityModel>(
    props.curAddr || { name: '上海', cityId: 145, cityName: '上海' },
  );
  // 在线点餐
  const [onLineOrderList, setOnLineOrderList] = useState<any[]>([]);
  const [init, setInit] = useState(true);
  var tabDataTime: any;
  useEffect(() => {
    if (props.showAddrModal) {
      increaseLoading();
      homeReq.getCityList('').finally(() => {
        decreaseLoading();
      }).then((data) => {
        if (data) {
          setCityList(data.cityList);
          setHotCity(data.hotCities);
          setHistoryCities(data.historyCities);
        }
      });
    }
  }, [props.showAddrModal]);
  /** #### 选择城市 end #### */

  // 存储 indexType
  useEffect(() => {
    if (!indexType) {
      return;
    }
    const oldIndexType = parseInt(getSessonStorage('indextype') || '');
    if (indexType !== oldIndexType && oldIndexType !== NaN) {
      setSessonStorage('indextype', indexType);
    }
  }, [indexType]);
  useEffect(() => {
    if (getQueryString('reloadType')) {
      setIndexType(EIndexTypes.hot);
    } else {
      const oldIndexType = parseInt(getSessonStorage('indextype') || '');
      if (oldIndexType && oldIndexType !== NaN) {
        setIndexType(oldIndexType);
      } else {
        setIndexType(EIndexTypes.hot);
        setSessonStorage('indextype', EIndexTypes.hot);
      }
    }
    // 重置操作缓存
    props.dispatch && props.dispatch({ type: 'movie/setUserDataParams', payload: null });

    // 顶部tab曝光事件
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部导航', elementname: '热映', floorNum: 1 }, 'DF_exposureEvent',);
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部导航', elementname: '影院', floorNum: 1 }, 'DF_exposureEvent',);
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部导航', elementname: '待映', floorNum: 1 }, 'DF_exposureEvent',);
  }, []);

  useEffect(() => {
    homeApi.getAudioAndVideoList().then((res) => {
      if (res) {
        setAudioInfo(res);
      }
    });
    homeApi.getOnlineOrderingList().then((res) => {
      if (res) {
        setOnLineOrderList(res || []);
      }
    });
  }, []);

  useEffect(() => {
    homeApi.getBannerList().then((res) => {
      if (res) {
        setBannerList(res);
      }
    });
  }, [props.curAddr]);
  useEffect(() => {
    if (!props.curAddr) {
      return;
    }
    setInit(true);
    clearSession();
    increaseLoading();
    loadData().finally(() => {
      decreaseLoading();
      setInit(false);
    });
    setCurentCity(props.curAddr);
  }, [props.curAddr, indexType]);

  const clearSession = () => {
    // 清除电影曝光埋点数据
    sessionStorage.removeItem('film_homeMovie');
  };

  const loadData = () => {
    const p: Promise<any>[] = [];
    //  ==========================================
    if (indexType === EIndexTypes.future) {
      props.dispatch && props.dispatch({ type: 'home/SetMenuBarObj', payload: { type: 3 } });
      let paramsSoon = { orderDescs: [{ col: 'hot', asc: false }] };
      p.push(
        homeApi.getSoonMovieList(paramsSoon).then((res) => {
          if (res) {
            setFutureMovieData(res);
          }
        })
      );
    } else if (indexType === EIndexTypes.hot) {
      props.dispatch && props.dispatch({ type: 'home/SetMenuBarObj', payload: { type: 3 } });
      p.push(
        timer(60).then(() => homeApi.getMovieTop()).then((res) => {
          if (res) {
            setMovieTopData(res);
          }
        })
      );
      p.push(
        timer(150).then(() => homeApi.getHotMovieList({ orderDescs: [{ col: 'hot', asc: false }] })).then((res) => {
          if (res) {
            setHotMovieData(res);
          }
        })
      );
    }

    return Promise.all(p);
  };

  // loadMore
  function requestLoadMore(type) {
    if (type === EIndexTypes.future) {
      let params = { pageIndex: futurePageIndex + 1, orderDescs: [{ col: 'hot', asc: false }] };
      homeApi.getSoonMovieList(params).then((res) => {
        //res.hasNext
        const obj = {
          hasNext: res.hasNext,
          totalCount: res.totalCount,
          searches: futureMovieData
            ? [...futureMovieData.searches, ...res.searches]
            : [...res.searches]
        };
        setFutureMovieData(obj);
        setFuturePageIndex(futurePageIndex + 1);
      });
    } else if (type === EIndexTypes.hot) {
      // res.hasNext
      // 与后台确认写死H5排序 02/26
      let params = { pageIndex: hotPageIndex + 1, orderDescs: [{ col: 'hot', asc: false }] };
      homeApi.getHotMovieList(params).then((res) => {
        //res.hasNext
        const obj = {
          hasNext: false,
          totalCount: res.totalCount,
          searches: hotMovieData ? [...hotMovieData.searches, ...res.searches] : [...res.searches]
        };
        setHotMovieData(obj);
        setHotPageIndex(hotPageIndex + 1);
      });
    }
  }


  const changeCity = async (city?: types.CityModel, id?: number) => {
    // console.log('changeCity', city, id);
    props.dispatch &&
      props.dispatch({
        type: 'initData/setShowAddrPage',
        payload: false
      });
    if (!city) {
      return;
    }
    props.dispatch &&
      props.dispatch({
        type: 'home/SetMenuBarObj',
        payload: {
          type: 3
        }
      });
    if (BFD_checkApp() && city) {
      BFD_changeAppAddress(city.name, city.cityId);
    }
    if (city) {
      const isEN = getCookie('df_lang') === 'en-US';
      increaseLoading();
      await DFWebUtilsTools.initAddressDF(false, null, isEN, city.cityId).then((data) => {
        DFWebUtilsTools.setCatchAddress(
          data?.provinceId,
          data?.provinceName,
          data?.provinceName,
          data?.cityId,
          data?.cityName,
          data?.cityName,
          data?.regionId,
          data?.regionName,
          data?.regionName,
          data?.streetId,
          data?.streetName,
          data?.streetName,
          data?.addressId,
          data?.address,
        );
      }).finally(() => decreaseLoading());
      props.dispatch &&
        props.dispatch({
          type: 'initData/setAddress',
          payload: city
        });

    }
  };

  const getContentDom = (indexType) => {
    switch (indexType) {
      case EIndexTypes.future:
        if (init) {
          return (
            <FutureSkeleton></FutureSkeleton>
          );
        }
        return (
          <IndexLayout
            data={futureMovieData}
            onlineOrderList={onLineOrderList}
            banner={bannerImgs}
            type={EIndexTypes.future}
            loadMore={requestLoadMore}
            init={init}
          />
        );
      case EIndexTypes.hot:
        if (init) {
          return (
            <HotSkeleton></HotSkeleton>
          );
        }
        return (
          <IndexLayout
            data={hotMovieData}
            audioInfo={audioInfo}
            onlineOrderList={onLineOrderList}
            banner={bannerImgs}
            top={movieTopData}
            type={EIndexTypes.hot}
            loadMore={requestLoadMore}
            init={init}
          />
        );
      case EIndexTypes.cinema:
        return <Cinema banner={bannerImgs} onlineOrderList={onLineOrderList} city={props.curAddr} />;
      default:
        return null;
    }
  };
  const changeIndexType = (type, name) => {
    if (type == indexType) return;
    setInit(true);
    gioClick('电影-频道首页', { pagename: '电影首页', channle: '电影', modulename: '顶部导航', elementname: name, floorNum: 1 });
    setIndexType(type);
  };

  return (
    <Context.Provider value={{ state, dispatch }}>
      <div className="home">
        <div className="typeContainer">
          <ul className="items">
            <li
              className={classnames('item', { active: indexType === EIndexTypes.hot })}
              onClick={() => changeIndexType(EIndexTypes.hot, '热映')}
            >
              {TLang('热映', 'home', false, false, null)}
            </li>
            <li
              className={classnames('item', { active: indexType === EIndexTypes.cinema })}
              onClick={() => changeIndexType(EIndexTypes.cinema, '影院')}
            >
              {TLang('影院', 'home', false, false, null)}
            </li>
            <li
              className={classnames('item', { active: indexType === EIndexTypes.future })}
              onClick={() => changeIndexType(EIndexTypes.future, '待映')}
            >
              {TLang('待映', 'home', false, false, null)}
            </li>
          </ul>
        </div>
        {getContentDom(indexType)}
        <Modal visible={props.showAddrModal} popup animationType="slide-up">
          {/* <SelectCity onClose={closeAddrPage}/> */}
          <SelectCityPart
            historyCities={historyCities}
            hotCity={hotCity}
            cityList={cityList}
            curentCity={curentCity}
            showLoading={false}
            onClose={changeCity}
          ></SelectCityPart>
        </Modal>
        <MarketingPopup
          channelId={1}
          pageHomeType={1}
          cityId={commonGetCityId()}
          gioExposeEvent={(value) => {
            gioClick('电影', {
              pagename: '电影',
              modulename: '商城弹窗',
              elementname: '图片',
              contentTitle: '电影',
              content: value?.name,
              activityid: value?.id,
              JumpAddress: value?.link
            }, 'DF_exposureEvent');
            gioClick('电影', {
              pagename: '电影',
              modulename: '商城弹窗',
              elementname: '关闭',
              contentTitle: '电影',
              content: value?.name,
              activityid: value?.id,
              JumpAddress: value?.link
            }, 'DF_exposureEvent');
          }}
          onClick={(type, value) => {
            gioClick('电影', {
              pagename: '电影',
              modulename: '商城弹窗',
              elementname: type == 'jump' ? '图片' : '关闭',
              contentTitle: '电影',
              content: value?.name,
              activityid: value?.id,
              JumpAddress: value?.link
            });
          }}
        />
      </div>
    </Context.Provider>
  );
};
const mapStatus = ({ initData }) => ({
  curAddr: initData.currentAddress,
  showAddrModal: initData.showAddrPage
});
export default connect(mapStatus)(Home);
